angular.module('elfium').controller('taskDetailModalController', ['$rootScope', '$scope', '$uibModalInstance', '$timeout', '$q', 'taskService', 'elfiumToastrService', 'elfiumLoginService', 'elfiumModalFactory', 'elfiumRelatedOptionsService', 'taskId', 'businessCaseId', 'taskData', 'businessCaseService', 'elfiumUrlService', 'elfiumMissingRequiredFieldsFilter', 'taskSplitByTypeFilter', 'ELFIUM_SELECT_OPTIONS', 'TASK_REQUIRED_FIELDS', 'TASK_STATES', 'TASK_TYPES',
    function ($rootScope, $scope, $uibModalInstance, $timeout, $q, taskService, elfiumToastrService, elfiumLoginService, elfiumModalFactory, elfiumRelatedOptionsService, taskId, businessCaseId, taskData, businessCaseService, elfiumUrlService, elfiumMissingRequiredFieldsFilter, taskSplitByTypeFilter, ELFIUM_SELECT_OPTIONS, TASK_REQUIRED_FIELDS, TASK_STATES, TASK_TYPES) {
        var that = this;
        that.elfiumModal = null;
        $scope.taskDetailModalBody = elfiumUrlService.getTemplateUrl('task', 'taskDetailModalBody');
        $scope.selectOptions = ELFIUM_SELECT_OPTIONS;
        $scope.taskTypeOptions = TASK_TYPES;
        $scope.canChangeBusinessCaseAndStatus = true;
        that.existingTasksByType = {};
        that.initialize = function () {
            that.buildtask().then(function (task) {
                $scope.task = task;
                that.elfiumModal = new elfiumModalFactory($scope, $uibModalInstance, task);
                that.getRelatedOptions();
            });
        };
        that.buildtask = function () {
            var deferred = $q.defer();
            if (taskId) {
                that.getTask(taskId, deferred);
            } else {
                var newTask = angular.extend({
                    stav: TASK_STATES.NAPLANOVANO,
                    obchodniPripadId: businessCaseId,
                    userId: elfiumLoginService.getUserId()
                }, taskData);
                deferred.resolve(newTask);
            }
            return deferred.promise;
        };
        that.getTask = function (taskId, deferred) {
            taskService.getTask(taskId).then(deferred.resolve, deferred.reject);
        };
        that.isTaskOpen = function () {
            return $scope.task.stav === TASK_STATES.NAPLANOVANO;
        };
        that.isNotANewTask = function () {
            return $scope.task && $scope.task.id;
        };
        that.getRelatedOptions = function () {
            elfiumRelatedOptionsService.getUserOptions().then(function (userOptions) {
                $scope.userOptions = userOptions;
            }, elfiumToastrService.error);
            elfiumRelatedOptionsService.getBusinessCaseOptions().then(function (businessCaseOptions) {
                $scope.businessCaseOptions = businessCaseOptions;
            }, elfiumToastrService.error);
        };
        that.upsertTask = function () {
            return taskService.upsertTask($scope.task).then(function () {
                that.elfiumModal.mainObjectSaved();
                elfiumToastrService.success('Úkol byl přidán / aktualizován!');
                $uibModalInstance.close();
            }, elfiumToastrService.error);
        };
        that.getDataForBusinessCase = function (businessCaseId) {
            elfiumRelatedOptionsService.getContactOptionsForBusinessCase(businessCaseId).then(function (contactOptions) {
                $scope.contactOptions = contactOptions;
            }, elfiumToastrService.error);
            businessCaseService.getBusinessCase(businessCaseId).then(function (businessCase) {
                $scope.firma = businessCase.firma.nazev;
            });
            that.loadExistingTasksForBusinessCase(businessCaseId);
        };
        that.loadExistingTasksForBusinessCase = function (businessCaseId) {
            var searchParameters = {
                obchodniPripadId: businessCaseId
            };
            $scope.isLoading = true;
            taskService.searchTasks(searchParameters).then(function (tasks) {
                that.existingTasksByType = taskSplitByTypeFilter(tasks);
                that.prefillValuesFromPreviousTaskIfNeeded(tasks);
                $scope.isLoading = false;
            }, elfiumToastrService.error);
        };
        that.prefillValuesFromPreviousTaskIfNeeded = function (tasks) {
            if (!$scope.task.id) {
                var newestTask = that.getNewestTaskFromList(tasks);
                $scope.task.castka = newestTask.castka;
                $scope.task.kontaktId = newestTask.kontaktId;
            }
        };
        that.getNewestTaskFromList = function (tasks) {
            var newestTask = null;
            angular.forEach(tasks, function (task) {
                if (!newestTask || newestTask.id < task.id) {
                    newestTask = task;
                }
            });
            return newestTask;
        };
        that.hasTaskOfEarlierDateOfType = function (date, type) {
            var hasTaskOfEarlierDateOfType = false;
            angular.forEach(that.existingTasksByType[type], function (task) {
                if (task.termin < date) {
                    hasTaskOfEarlierDateOfType = true;
                }
            });
            return hasTaskOfEarlierDateOfType;
        };
        that.hasTaskOfLaterDateOfType = function (date, type) {
            var hasTaskOfEarlierDateOfType = false;
            angular.forEach(that.existingTasksByType[type], function (task) {
                if (task.termin > date) {
                    hasTaskOfEarlierDateOfType = true;
                }
            });
            return hasTaskOfEarlierDateOfType;
        };
        that.isNotValidTaskDate = function () {
            var isNotValidTaskDate = false;
            switch ($scope.task.typ) {
                case TASK_TYPES.KOTEVRENI:
                    isNotValidTaskDate = that.hasTaskOfEarlierDateOfType($scope.task.termin, TASK_TYPES.POTREBA);
                    break;
                case TASK_TYPES.POTREBA:
                    isNotValidTaskDate = that.hasTaskOfEarlierDateOfType($scope.task.termin, TASK_TYPES.NABIDKA) || that.hasTaskOfLaterDateOfType($scope.task.termin, TASK_TYPES.KOTEVRENI);
                    break;
                case TASK_TYPES.NABIDKA:
                    isNotValidTaskDate = that.hasTaskOfEarlierDateOfType($scope.task.termin, TASK_TYPES.KUZAVRENI) || that.hasTaskOfLaterDateOfType($scope.task.termin, TASK_TYPES.POTREBA);
                    break;
                case TASK_TYPES.KUZAVRENI:
                    isNotValidTaskDate = that.hasTaskOfLaterDateOfType($scope.task.termin, TASK_TYPES.NABIDKA);
            }
            return isNotValidTaskDate;
        };
        that.hasTasksInNextType = function () {
            return ($scope.task.typ == TASK_TYPES.KOTEVRENI && that.existingTasksByType[TASK_TYPES.POTREBA].length) 
                || ($scope.task.typ == TASK_TYPES.POTREBA && that.existingTasksByType[TASK_TYPES.NABIDKA].length) 
                || ($scope.task.typ == TASK_TYPES.NABIDKA && that.existingTasksByType[TASK_TYPES.KUZAVRENI].length);
        };
        that.hasOtherOpenOrSuccessfulTasksOfThisType = function () {
            var hasOtherOpenOrSuccessfulTasksOfThisType = false;
            for (var i = 0; i < that.existingTasksByType[$scope.task.typ].length; ++i) {
                var loopTask = that.existingTasksByType[$scope.task.typ][i];
                var isLoopTaskCurrentTask = loopTask.id != $scope.task.id;
                var isLoopTaskOpen = loopTask.stav == TASK_STATES.NAPLANOVANO;
                var isLoopTaskSuccessful = loopTask.stav == TASK_STATES.SPLNENO;
                if (isLoopTaskCurrentTask && (isLoopTaskOpen || isLoopTaskSuccessful)) {
                    hasOtherOpenOrSuccessfulTasksOfThisType = true;
                    break;
                }
            }
            return hasOtherOpenOrSuccessfulTasksOfThisType;
        };
        that.canFailTask = function () {
            return !that.hasTasksInNextType() || that.hasOtherOpenOrSuccessfulTasksOfThisType();
        };
        that.refreshList = function () {
            $rootScope.$emit('refreshTaskList');
        };
        that.getTaskCopy = function () {
            var taskCopy = angular.copy($scope.task);
            delete taskCopy.id;
            delete taskCopy.stav;
            return taskCopy;
        }
        $scope.canCloseTask = function () {
            return that.isNotANewTask() && $scope.canChangeBusinessCaseAndStatus && that.isTaskOpen();
        };
        $scope.okClicked = function () {
            var deferred = $q.defer();
            $timeout(function () {
                var missingRequiredFields = elfiumMissingRequiredFieldsFilter($scope.task, TASK_REQUIRED_FIELDS);
                if (missingRequiredFields.length) {
                    elfiumToastrService.error('Vyplňte povinné údaje: ' + missingRequiredFields.join(', '));
                    deferred.reject();
                } else if (that.isNotValidTaskDate()) {
                    elfiumToastrService.error('Již je naplánovaný úkol v další fázi s dřívějším termínem / v předchozí fázi s pozdějším termínem.')
                    deferred.reject();
                } else {
                    that.upsertTask().then(deferred.resolve, deferred.reject);
                }
            });
            return deferred.promise;
        };
        that.okClickedAndOfferCreateNewTask = function () {
            $scope.okClicked().then(taskService.shouldCreateNewTaskModal).then(function () {
                return taskService.openTaskDetailModal(null, null, that.getTaskCopy());
            }).then(that.refreshList);
        };
        $scope.taskSucceededClicked = function () {
            $scope.task.stav = TASK_STATES.SPLNENO;
            that.okClickedAndOfferCreateNewTask();
        };
        $scope.taskFailedClicked = function () {
            if (that.canFailTask()) {
                $scope.task.stav = TASK_STATES.NESPLNENO;
                that.okClickedAndOfferCreateNewTask();
            } else {
                elfiumToastrService.error('Již je naplánovaný úkol v další fázi. Pro nesplnění tohoto úkolu nejprve otevřete nový úkol v této fázi.')
            }
        };
        $scope.getPriorityButtonLabel = function () {
            return ($scope.task && $scope.task.priorita) ? 'Zrušit prioritní' : 'Nastavit prioritní';
        };
        $scope.togglePriority = function () {
            $scope.task.priorita = !$scope.task.priorita;
            $scope.okClicked();
        };
        $scope.$watch('task.obchodniPripadId', function (newValue) {
            if (newValue) {
                that.getDataForBusinessCase(newValue);
            }
        });
        that.initialize();
    }
]);


// WEBPACK FOOTER //
// ./src/app/components/task/taskDetailModalController.ts